module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/cards/cards-style10/cards-style10.component.scss
// module id = ./src/app/features/cards/cards-style10/cards-style10.component.scss
// module chunks = main